import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

let nextModalHeaderId = 0;

/** Shared heading for form, table and document dialogs. */
@Component({
  selector: 'app-modal-header',
  standalone: true,
  imports: [NgIf, MatDialogModule, MatIconModule],
  templateUrl: './modal-header.component.html',
  styleUrls: ['./modal-header.component.scss']
})
export class ModalHeaderComponent {
  @Input() title = '';
  @Input() icon = 'info_outline';
  @Input() titleId = `modal-heading-${nextModalHeaderId++}`;
  @Input() closeLabel = 'Close dialog';
  @Input() closeDisabled = false;
  /** Hides the icon and heading visually (kept for screen readers) when the content brings its own title. */
  @Input() hideTitle = false;
  /** One-row layout (left-aligned title, no icon badge) for dialogs where vertical space matters. */
  @Input() compact = false;
  @Output() closed = new EventEmitter<void>();
}
